import React from "react";
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import LeadAnalisiPieSet from "./LeadAnalisi.PieSet";
import LeadAnalisiKPISet from "./LeadAnalisi.KPISet";

const LeadAnalisi = ({ dataProviderName, filters, $key }) => {
    const { t } = useTranslation();

    const showKPI = true;
    const showPIE = true;

    return (
        <Box className="dashboard-page" key={$key}>
            <Box className="dashboard-page-title">
                <h2>{t('Leads')}</h2>
            </Box>

            {showKPI &&
                <Box className="report-itemgroup">
                    <LeadAnalisiKPISet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

            {showPIE &&
                <Box className="report-itemgroup">
                    <LeadAnalisiPieSet dataProviderName={dataProviderName} filters={filters} />
                </Box>
            }

        </Box>
    )
}

export default LeadAnalisi;
